import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { FormInputProps } from "../../models/form.model";
import { useConfig } from "../../containers/ConfigContext";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  style: {
    zIndex: 1302,
  },
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export interface SelectionOption {
  label: string | React.ReactNode;
  image?: string;
  value: string | number | boolean;
  disabled?: boolean;
}

export default function FormSelection(
  props: FormInputProps & {
    options: SelectionOption[];
    noEmpty?: boolean;
    emptyText?: string;
    multiple?: boolean;
    disabled?: boolean;
  },
) {
  const {
    name,
    control,
    emptyText,
    noEmpty,
    label,
    helperText,
    rules,
    required,
    multiple,
    options,
    setError,
    disabled,
  } = props;
  const { localized } = useConfig();
  const setErrorMsg = (message: string) => {
    setError(name, { type: "manual", message });
  };
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, value: values = multiple ? [] : "" },
        fieldState: { error },
        formState,
      }) => {
        if (multiple) {
          values = Array.isArray(values) ? values : [];
        } else {
          values = Array.isArray(values) ? "" : values;
        }
        return (
          <FormControl
            error={!!error}
            required={required}
            className="width-100p"
            sx={{ my: 1 }}
          >
            <InputLabel>{label}</InputLabel>
            <Select
              multiple={multiple}
              autoComplete="off"
              value={values}
              disabled={disabled}
              onChange={(e) => {
                const {
                  target: { value },
                } = e;
                onChange(
                  multiple
                    ? typeof value === "string"
                      ? value.split(",")
                      : value
                    : value,
                );
              }}
              input={<OutlinedInput label={label} />}
              renderValue={(selected) => {
                return options
                  .filter((a) =>
                    multiple
                      ? ~selected.indexOf(`${a.value}`)
                      : selected == a.value,
                  )
                  .map((v) => v.label)
                  .join(", ");
              }}
              MenuProps={MenuProps}
            >
              {!noEmpty && (
                <MenuItem value="">
                  <em>{emptyText || localized("None")}</em>
                </MenuItem>
              )}

              {options.map((op, i) => (
                <MenuItem
                  disabled={op.disabled}
                  key={op.value + "_" + i}
                  value={op.value.toString()}
                >
                  {multiple && (
                    <Checkbox
                      checked={
                        values && values.indexOf(op.value.toString()) > -1
                      }
                    />
                  )}
                  <ListItemText primary={op.label} />
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>
              {error ? error.message : helperText || null}
            </FormHelperText>
          </FormControl>
        );
      }}
    />
  );
}
